var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"black-outset d-flex align-items-center",attrs:{"id":"navbar"}},[_c('div',{staticClass:"w-100 h-100"},[_c('base-nav',{attrs:{"data":_vm.base,"active":_vm.type}}),_c('sections-nav',{attrs:{"data":_vm.sections}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }